import { useEffect } from 'react'
import { ProjectWrapper, LinkButton } from '../../GlobalStyles'
import { ViewAllProjects } from '../../components/ViewAllProjects'
import { Carousel } from '../../components/Carousel'
import wave from '../../assets/white-wave.svg'

import image1 from '../../assets/ticket-widget/ticket-widget1.png'
import image2 from '../../assets/ticket-widget/ticket-widget2.png'
import image3 from '../../assets/ticket-widget/ticket-widget3.png'
import image4 from '../../assets/ticket-widget/ticket-widget4.png'
import image5 from '../../assets/ticket-widget/ticket-widget5.png'
import image6 from '../../assets/ticket-widget/ticket-widget6.png'
import image7 from '../../assets/ticket-widget/ticket-widget7.png'
import image8 from '../../assets/ticket-widget/ticket-widget8.png'
import image9 from '../../assets/ticket-widget/sticker-sheet.png'

export const TicketWidget = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const projectImages = [
    image1,
    image2,
    image3,
    image4,
    image5,
    image6,
    image7,
    image8,
    image9,
  ]

  return (
    <ProjectWrapper>
      <div
        className='banner'
        style={{ background: 'linear-gradient(to right, #D9B3FF, #7E1AC1)' }}
      >
        <img src={wave} alt='decorative wave' />
      </div>

      <section className='description'>
        <h1 className='title'>[ <b>TicketWidget</b> ]</h1>
        <div className='summary'>
          <p className='type'>UX Design, Mobile App</p>
          <p className='duration'>Solo Project • May – Aug 2022</p>
        </div>

        <div className='details'>
          <p>
            TicketWidget streamlines global concert ticket discovery and purchase in a single mobile interface. Users filter events by date, location, and genre, select seats, and complete checkout seamlessly within the app.
          </p>
        </div>

        <div style={{ margin: '40px 0' }}>
          <Carousel images={projectImages} />
        </div>

        <div className='details'>
          <p>
            Executed full UX process: user interviews, competitive audit, wireframes, high-fidelity prototypes, and iterative usability testing in Figma. Each feedback cycle informed refinements to navigation, ticket selection flows, and visual hierarchy.
          </p>
          <p>
            Developed comprehensive sticker sheets and design systems to ensure consistency across screens and facilitate developer handoff.
          </p>
        </div>

        <div className='buttons'>
          <LinkButton
            className='black'
            href='https://www.figma.com/proto/aXXruSP5WHIyzSXOSDMc7S/TicketWidget?scaling=scale-down&page-id=137%3A1361&node-id=137%3A1442&starting-point-node-id=137%3A1442'
            target='_blank'
            rel='noopener noreferrer'
          >
            View Prototype
          </LinkButton>
          <LinkButton
            className='white'
            href='https://docs.google.com/presentation/d/1VU-9AZ_CmoytlepkZCGBrDUe6OvLFeB40ww8Drj-rPE/edit?usp=sharing'
            target='_blank'
            rel='noopener noreferrer'
          >
            View Case Study
          </LinkButton>
        </div>
      </section>

      <ViewAllProjects />
    </ProjectWrapper>
  )
}
